/* projects/shared/nvps-libraries/design/nv-dropdown-item/nv-dropdown-item.component.scss */
:host.isdisabled button,
nv-dropdown-item.isdisabled button {
  opacity: 0.5;
  cursor: not-allowed;
}
:host button.mat-mdc-menu-item,
nv-dropdown-item button.mat-mdc-menu-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
:host button.mat-mdc-menu-item .mdc-list-item__primary-text,
:host button.mat-mdc-menu-item .mat-mdc-menu-item-text,
nv-dropdown-item button.mat-mdc-menu-item .mdc-list-item__primary-text,
nv-dropdown-item button.mat-mdc-menu-item .mat-mdc-menu-item-text {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
:host button.mat-mdc-menu-item ::last-child,
nv-dropdown-item button.mat-mdc-menu-item ::last-child {
  border: none;
}
:host button.mat-mdc-menu-item .dropdown-item-label,
nv-dropdown-item button.mat-mdc-menu-item .dropdown-item-label {
  font-size: 14px;
  letter-spacing: 0.0168em;
  line-height: 145%;
  font-family: var(--font-family-normal);
  font-style: normal;
  font-weight: 400;
  font-family: var(--font-family-normal);
  font-weight: 400;
  text-transform: none;
  color: var(--color-blue);
  margin-right: 24px;
  display: flex;
  align-items: center;
  gap: var(--space-s);
}
:host button.mat-mdc-menu-item .dropdown-item-label.delete-note,
nv-dropdown-item button.mat-mdc-menu-item .dropdown-item-label.delete-note {
  color: var(--color-red);
}
:host button.mat-mdc-menu-item .dropdown-item-label.not-text-transform,
nv-dropdown-item button.mat-mdc-menu-item .dropdown-item-label.not-text-transform {
  text-transform: none;
}
:host button.mat-mdc-menu-item.mat-mdc-menu-item-submenu-trigger,
nv-dropdown-item button.mat-mdc-menu-item.mat-mdc-menu-item-submenu-trigger {
  padding-right: 16px;
}
:host button.mat-mdc-menu-item.mat-mdc-menu-item-submenu-trigger .mat-mdc-menu-submenu-icon,
nv-dropdown-item button.mat-mdc-menu-item.mat-mdc-menu-item-submenu-trigger .mat-mdc-menu-submenu-icon {
  display: none;
}
:host button.mat-mdc-menu-item.mat-mdc-menu-item-submenu-trigger nv-icon,
nv-dropdown-item button.mat-mdc-menu-item.mat-mdc-menu-item-submenu-trigger nv-icon {
  width: var(--space-m);
  height: var(--space-m);
}
:host button.mat-mdc-menu-item:hover:not([disabled]),
:host button.mat-mdc-menu-item.mat-mdc-menu-item-highlighted:not([disabled]),
nv-dropdown-item button.mat-mdc-menu-item:hover:not([disabled]),
nv-dropdown-item button.mat-mdc-menu-item.mat-mdc-menu-item-highlighted:not([disabled]) {
  background-color: var(--color-blue-5);
}
:host button.mat-mdc-menu-item:hover:not([disabled]).delete-note,
:host button.mat-mdc-menu-item.mat-mdc-menu-item-highlighted:not([disabled]).delete-note,
nv-dropdown-item button.mat-mdc-menu-item:hover:not([disabled]).delete-note,
nv-dropdown-item button.mat-mdc-menu-item.mat-mdc-menu-item-highlighted:not([disabled]).delete-note {
  background-color: var(--color-red-5);
}
:host button.mat-mdc-menu-item.cdk-focused:active .dropdown-item-label.delete-note:not([disabled]),
:host button.mat-mdc-menu-item.cdk-focused:not([disabled]):active .dropdown-item-label.delete-note:not([disabled]),
nv-dropdown-item button.mat-mdc-menu-item.cdk-focused:active .dropdown-item-label.delete-note:not([disabled]),
nv-dropdown-item button.mat-mdc-menu-item.cdk-focused:not([disabled]):active .dropdown-item-label.delete-note:not([disabled]) {
  color: var(--color-white);
}
:host button.mat-mdc-menu-item.cdk-focused:active .dropdown-item-label.edit-note:not([disabled]),
:host button.mat-mdc-menu-item.cdk-focused:not([disabled]):active .dropdown-item-label.edit-note:not([disabled]),
nv-dropdown-item button.mat-mdc-menu-item.cdk-focused:active .dropdown-item-label.edit-note:not([disabled]),
nv-dropdown-item button.mat-mdc-menu-item.cdk-focused:not([disabled]):active .dropdown-item-label.edit-note:not([disabled]) {
  color: var(--color-white);
}
:host button.mat-mdc-menu-item.cdk-focused.delete-note:not([disabled]),
:host button.mat-mdc-menu-item.cdk-focused:not([disabled]).delete-note:not([disabled]),
nv-dropdown-item button.mat-mdc-menu-item.cdk-focused.delete-note:not([disabled]),
nv-dropdown-item button.mat-mdc-menu-item.cdk-focused:not([disabled]).delete-note:not([disabled]) {
  background-color: var(--color-red);
}
:host button.mat-mdc-menu-item.cdk-focused.edit-note:not([disabled]),
:host button.mat-mdc-menu-item.cdk-focused:not([disabled]).edit-note:not([disabled]),
nv-dropdown-item button.mat-mdc-menu-item.cdk-focused.edit-note:not([disabled]),
nv-dropdown-item button.mat-mdc-menu-item.cdk-focused:not([disabled]).edit-note:not([disabled]) {
  background-color: var(--color-blue);
}
:host button.mat-mdc-menu-item.selection,
:host button.mat-mdc-menu-item.selection:hover:not([disabled]),
:host button.mat-mdc-menu-item.selection:focus:not([disabled]),
nv-dropdown-item button.mat-mdc-menu-item.selection,
nv-dropdown-item button.mat-mdc-menu-item.selection:hover:not([disabled]),
nv-dropdown-item button.mat-mdc-menu-item.selection:focus:not([disabled]) {
  background-color: var(--color-blue);
}
:host button.mat-mdc-menu-item.selection span,
:host button.mat-mdc-menu-item.selection:hover:not([disabled]) span,
:host button.mat-mdc-menu-item.selection:focus:not([disabled]) span,
nv-dropdown-item button.mat-mdc-menu-item.selection span,
nv-dropdown-item button.mat-mdc-menu-item.selection:hover:not([disabled]) span,
nv-dropdown-item button.mat-mdc-menu-item.selection:focus:not([disabled]) span {
  color: white;
}
:host button.mat-mdc-menu-item.parent-of-selection,
:host button.mat-mdc-menu-item.parent-of-selection:focus:not([disabled]),
:host button.mat-mdc-menu-item.parent-of-selection:hover:not([disabled]),
nv-dropdown-item button.mat-mdc-menu-item.parent-of-selection,
nv-dropdown-item button.mat-mdc-menu-item.parent-of-selection:focus:not([disabled]),
nv-dropdown-item button.mat-mdc-menu-item.parent-of-selection:hover:not([disabled]) {
  background-color: var(--color-blue-light-5);
}
:host button.mat-mdc-menu-item.parent-of-selection.mat-mdc-menu-item-highlighted:not([disabled]),
:host button.mat-mdc-menu-item.parent-of-selection:focus:not([disabled]).mat-mdc-menu-item-highlighted:not([disabled]),
:host button.mat-mdc-menu-item.parent-of-selection:hover:not([disabled]).mat-mdc-menu-item-highlighted:not([disabled]),
nv-dropdown-item button.mat-mdc-menu-item.parent-of-selection.mat-mdc-menu-item-highlighted:not([disabled]),
nv-dropdown-item button.mat-mdc-menu-item.parent-of-selection:focus:not([disabled]).mat-mdc-menu-item-highlighted:not([disabled]),
nv-dropdown-item button.mat-mdc-menu-item.parent-of-selection:hover:not([disabled]).mat-mdc-menu-item-highlighted:not([disabled]) {
  background-color: var(--color-blue-light-5);
}
:host button.mat-mdc-menu-item .dropdown-item-label,
nv-dropdown-item button.mat-mdc-menu-item .dropdown-item-label {
  font-size: 14px;
  letter-spacing: 0.0168em;
  line-height: 145%;
  font-family: var(--font-family-normal);
  font-style: normal;
  font-weight: 400;
  font-family: var(--font-family-normal);
  font-weight: 400;
  text-transform: none;
  color: var(--color-grey-dark-9);
}
:host button.mat-mdc-menu-item:hover:not([disabled]),
nv-dropdown-item button.mat-mdc-menu-item:hover:not([disabled]) {
  background-color: var(--color-blue-light-5);
}
:host button.mat-mdc-menu-item.selection,
:host button.mat-mdc-menu-item.selection:focus:not([disabled]),
nv-dropdown-item button.mat-mdc-menu-item.selection,
nv-dropdown-item button.mat-mdc-menu-item.selection:focus:not([disabled]) {
  background-color: unset;
}
:host button.mat-mdc-menu-item.selection span,
:host button.mat-mdc-menu-item.selection:focus:not([disabled]) span,
nv-dropdown-item button.mat-mdc-menu-item.selection span,
nv-dropdown-item button.mat-mdc-menu-item.selection:focus:not([disabled]) span {
  color: var(--color-blue);
  font-weight: var(--font-weight-bold);
}
:host button.mat-mdc-menu-item.selection:hover,
:host button.mat-mdc-menu-item.selection:focus:not([disabled]):hover,
nv-dropdown-item button.mat-mdc-menu-item.selection:hover,
nv-dropdown-item button.mat-mdc-menu-item.selection:focus:not([disabled]):hover {
  background-color: var(--color-blue-light-5);
}
:host button.mat-mdc-menu-item.selection.parent-of-selection,
:host button.mat-mdc-menu-item.selection.parent-of-selection:hover:not([disabled]),
:host button.mat-mdc-menu-item.selection:focus:not([disabled]).parent-of-selection,
:host button.mat-mdc-menu-item.selection:focus:not([disabled]).parent-of-selection:hover:not([disabled]),
nv-dropdown-item button.mat-mdc-menu-item.selection.parent-of-selection,
nv-dropdown-item button.mat-mdc-menu-item.selection.parent-of-selection:hover:not([disabled]),
nv-dropdown-item button.mat-mdc-menu-item.selection:focus:not([disabled]).parent-of-selection,
nv-dropdown-item button.mat-mdc-menu-item.selection:focus:not([disabled]).parent-of-selection:hover:not([disabled]) {
  background-color: var(--color-blue-light-5);
}
:host button.mat-mdc-menu-item.selection.parent-of-selection.mat-mdc-menu-item-highlighted:not([disabled]),
:host button.mat-mdc-menu-item.selection.parent-of-selection:hover:not([disabled]).mat-mdc-menu-item-highlighted:not([disabled]),
:host button.mat-mdc-menu-item.selection:focus:not([disabled]).parent-of-selection.mat-mdc-menu-item-highlighted:not([disabled]),
:host button.mat-mdc-menu-item.selection:focus:not([disabled]).parent-of-selection:hover:not([disabled]).mat-mdc-menu-item-highlighted:not([disabled]),
nv-dropdown-item button.mat-mdc-menu-item.selection.parent-of-selection.mat-mdc-menu-item-highlighted:not([disabled]),
nv-dropdown-item button.mat-mdc-menu-item.selection.parent-of-selection:hover:not([disabled]).mat-mdc-menu-item-highlighted:not([disabled]),
nv-dropdown-item button.mat-mdc-menu-item.selection:focus:not([disabled]).parent-of-selection.mat-mdc-menu-item-highlighted:not([disabled]),
nv-dropdown-item button.mat-mdc-menu-item.selection:focus:not([disabled]).parent-of-selection:hover:not([disabled]).mat-mdc-menu-item-highlighted:not([disabled]) {
  background-color: var(--color-blue-light-5);
}
:host button.mat-mdc-menu-item.parent-of-selection,
:host button.mat-mdc-menu-item.parent-of-selection:hover:not([disabled]),
nv-dropdown-item button.mat-mdc-menu-item.parent-of-selection,
nv-dropdown-item button.mat-mdc-menu-item.parent-of-selection:hover:not([disabled]) {
  background-color: var(--color-blue-light-5);
}
:host button.mat-mdc-menu-item.parent-of-selection.mat-mdc-menu-item-highlighted:not([disabled]),
:host button.mat-mdc-menu-item.parent-of-selection:hover:not([disabled]).mat-mdc-menu-item-highlighted:not([disabled]),
nv-dropdown-item button.mat-mdc-menu-item.parent-of-selection.mat-mdc-menu-item-highlighted:not([disabled]),
nv-dropdown-item button.mat-mdc-menu-item.parent-of-selection:hover:not([disabled]).mat-mdc-menu-item-highlighted:not([disabled]) {
  background-color: var(--color-blue-light-5);
}
:host button.mat-mdc-menu-item .disabled-option-text,
nv-dropdown-item button.mat-mdc-menu-item .disabled-option-text {
  color: unset;
}
/*# sourceMappingURL=nv-dropdown-item.component-SXBHNCIJ.css.map */
